/**
 * <文件表请求接口
 * @author 王振宇
 * @since 2021-04-20
 */
export default (function (_ref) {
  var service = _ref.service,
    request = _ref.request,
    serviceForMock = _ref.serviceForMock,
    requestForMock = _ref.requestForMock,
    mock = _ref.mock,
    faker = _ref.faker,
    tools = _ref.tools;
  return {
    GET_FILE_PAGE_LIST: function GET_FILE_PAGE_LIST() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: '/admin/v1/file/getPageList',
        method: 'get',
        params: data
      });
    },
    GET_FILE_INFO: function GET_FILE_INFO() {
      return request({
        url: '/admin/v1/file/info',
        method: 'get'
      });
    },
    SAVE_FILE: function SAVE_FILE() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: '/admin/v1/file/save',
        method: 'post',
        data: data
      });
    },
    UPDATE_FILE: function UPDATE_FILE() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: '/admin/v1/file/update',
        method: 'put',
        data: data
      });
    },
    DELETE_FILE: function DELETE_FILE() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: '/admin/v1/file/delete',
        method: 'delete',
        data: data
      });
    },
    DELETE_BATCH_FILE: function DELETE_BATCH_FILE() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: '/admin/v1/file/deleteBatch',
        method: 'delete',
        data: data
      });
    }
  };
});